import { defineComponent as r, computed as a, createBlock as d, openBlock as f, unref as m, mergeProps as u, createSlots as c, withCtx as i, renderSlot as l } from "vue";
import { COMPONENT_NAME as g } from "./highrise178.mjs";
import { NPerformantEllipsis as h } from "./highrise346.mjs";
const y = r({
  name: g.ELLIPSIS,
  inheritAttrs: !1
}), O = /* @__PURE__ */ r({
  ...y,
  props: {
    id: {
      type: String,
      default: "hr-ellipsis-id"
    },
    expandOn: {
      type: String
    },
    lineClamp: {
      type: Number
    },
    tooltipProps: {
      type: Object,
      default: () => ({})
    },
    showTooltip: {
      type: Boolean,
      default: !0
    }
  },
  setup(t) {
    const e = t, n = {
      backgroundColor: "var(--gray-900)",
      color: "#fff",
      borderRadius: "4px",
      padding: "8px"
    }, p = {
      fontSize: "var(--font-size-sm)",
      lineHeight: "var(--line-height-sm)",
      fontWeight: "var(--font-weight-medium)"
    }, s = a(() => typeof e.tooltipProps == "object" && e.tooltipProps ? { ...e.tooltipProps, style: n, contentStyle: p } : e.tooltipProps);
    return (o, P) => (f(), d(m(h), u({
      id: t.id,
      "expand-trigger": t.expandOn,
      "line-clamp": t.lineClamp,
      tooltip: t.showTooltip ? s.value : !1
    }, o.$attrs), c({
      default: i(() => [
        l(o.$slots, "default")
      ]),
      _: 2
    }, [
      o.$slots.tooltip ? {
        name: "tooltip",
        fn: i(() => [
          l(o.$slots, "tooltip")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["id", "expand-trigger", "line-clamp", "tooltip"]));
  }
});
export {
  O as default
};
